export const initCustomSelect = () => {
  const dropdowns = document.querySelectorAll(".custom-select");

  dropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector(".custom-select__trigger");
    const menu = dropdown.querySelector(".custom-select__menu");
    const label = trigger.querySelector(".custom-select__label");
    const arrow = trigger.querySelector("i.ph-caret-down");

    if (!trigger || !menu || !label) return;

    trigger.addEventListener("click", (e) => {
      e.stopPropagation();
      dropdown.classList.toggle("open");
    });

    menu.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", (e) => {
        label.textContent = link.textContent;
        dropdown.classList.remove("open");
      });
    });

    document.addEventListener("click", () => {
      dropdown.classList.remove("open");
    });
  });
};
